import { useMemo } from 'react';
import { useUserRole } from '../../hooks/useUserRole';
import { createScopedStorage, type ScopedStorage } from '../utils/localStorageSettings';

/** Returns storage helpers scoped to the current user. */
export function useUserScopedStorage(): ScopedStorage {
  const { userId } = useUserRole();
  return useMemo(() => createScopedStorage(userId), [userId]);
}
